import type { AddDisposable } from '@amazon/vinyl-util'
import type { ManagedPlaylistController } from '@/playback/PlaylistController'
import { createStaticRenderPlayer } from '@/playback/staticRenderPlayer'
import { staticPage } from '@/staticRender'
import type { Player } from '@/playback/api'

export interface CreatePlayerOptions {
    readonly deps: { readonly playlistController: ManagedPlaylistController }
    readonly add: AddDisposable
    readonly errorHandler: (error: Error) => void
}

export async function createPlayer(options: CreatePlayerOptions): Promise<Player> {
    // Under a static render there's no interactive user and the
    // headless environment must never touch MSE/EME or a
    // `<video>`. Return a do-nothing stub that satisfies `Player`
    // WITHOUT importing `@amzn/vinyl-amzn` or creating the video
    // element; the delegate wiring below is pointless for a stub
    // that never plays, so skip it too.
    if (staticPage) {
        return createStaticRenderPlayer()
    }

    // The Vinyl + Audible engine subtree is heavy and never touched on first
    // paint, so it lives behind a dynamic import to stay off the eager boot
    // chunk. `playerPromise` is already awaited by every consumer.
    const { createInteractivePlayer } = await import('@/playback/interactivePlayer')
    return createInteractivePlayer(options)
}
